module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0052.jpg?v=f4eea4b4";